import { GROUP_CONTEST_OFFSET_DURATION } from '../data/groupContestOffsetDuration';
import addDaysToDate from 'utils/addDaysToDate';
import getNextDayAtMidnight from 'utils/getNextDayAtMidnight';

export default function getStartTimeOfNextInterviewbitTest({
  previousInterviewbitTest,
  currentInterviewbitTest,
  courseType,
  seq,
}) {
  let previousTestEndTime = previousInterviewbitTest.end_time;
  switch (Number(seq)) {
    case 0:
      return currentInterviewbitTest.start_time;
    case 1:
      return getNextDayAtMidnight(previousTestEndTime);
    case 2:
      return addDaysToDate({
        daysToAdd: courseType
          ? GROUP_CONTEST_OFFSET_DURATION[courseType][2]
          : 7,
        currentDate: previousTestEndTime,
      });
    case 3:
      return addDaysToDate({
        daysToAdd: courseType
          ? GROUP_CONTEST_OFFSET_DURATION[courseType][3]
          : 0,
        currentDate: previousTestEndTime,
      });
    default:
      return currentInterviewbitTest.start_time;
  }
}
